import { Input } from "@repo/ui/components/Base/Input";
import type { LegislationNumberField } from "./types";

export const LegislationNumberInput = ({
  disabled,
  field,
  id,
  label,
  value,
  onBlur,
  onChange,
}: {
  disabled?: boolean;
  field: LegislationNumberField;
  id: string;
  label: string;
  value: string;
  onBlur: (field: LegislationNumberField, value: string) => void;
  onChange: (field: LegislationNumberField, value: string) => void;
}) => (
  <Input
    disabled={disabled}
    id={id}
    label={label}
    labelStyle="text-sm"
    containerStyle="flex-grow"
    value={value}
    onChange={(evt) => {
      onChange(field, evt.target.value);
    }}
    onBlur={(evt) => {
      onBlur(field, evt.target.value);
    }}
  />
);
